// extracted by mini-css-extract-plugin
export var dividerContainer = "_a6-0";
export var line = "_a6-1";